import React, { Component } from 'react'
import withRouter from '../lib/withRouter';
import { connect } from 'react-redux';
import Authentication from '../../session';
import Service from '../services'
import { BasicLazyParams } from '../../utile';
import BranchToSectionMultiDDTillSecReports from '../BaseDropdownComponents/BranchToSectionMultiDDTillSecReports';
import { getBranchesLatest } from '../../store/actions';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import './styles.scss'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { baseUrlAdmin } from '../../store/apiConstants';
import { Toast } from 'primereact/toast';
import moment from 'moment';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import ClassetCalendar from '../../classetComponents/classetCalender';



class AttendanceSummaryReport extends Component {
  render() {
    return (
      <div>attendanceSummaryReport</div>
    )
  }
}
const mapStatesToProps = (state) => ({
    isLoading: state.boardsData.loading,
    isBranchLoading: state.branchDataLatest.isLoading,
    branchLevels: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.levels,
    branchData:
        (state.branchDataLatest &&
            state.branchDataLatest.data &&
            state.branchDataLatest.data.data?.filter((each) => {
                if (each.level == 1) {
                    return { ...each };
                }
            })) ||
        [],
    _id: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data._idF
});
export default connect(mapStatesToProps, { getBranchesLatest })(Authentication(withRouter(AttendanceSummaryReport)));